import { Button, Input, message, Modal, Space } from "antd"
import { useState } from "react"
import { useSearchParams } from "react-router-dom"
import { useActions } from "../../../hooks/useActions"
import projectDataApi from "../api/projectDataKeywordsApi"

const { TextArea } = Input

const AddKeywords: React.FC = () => {
  const [open, setOpen] = useState(false)
  const [keywords, setKeywords] = useState("")

  const [searchParams] = useSearchParams()
  const projectId = searchParams.get("projectId")
  const { getProjectDataKeywords, getProject } = useActions()

  function addKeywords() {
    if (!projectId) {
      return
    }

    const keywordsArray = keywords
      .split(/[\n\r,]+/)
      .map((keyword) => keyword.trim())
      .filter((keyword) => keyword.length > 0)

    projectDataApi
      .addKeyword(projectId, keywordsArray)
      .then(() => {
        setOpen(false)
        setKeywords("")
        getProjectDataKeywords(projectId)
        getProject(projectId)
      })
      .catch((error) => {
        message.error(error)
      })
  }

  return (
    <>
      <Button onClick={() => setOpen(true)}>Add keywords</Button>

      <Modal
        title="Add Keywords"
        open={open}
        onCancel={() => setOpen(false)}
        footer={
          <Space>
            <Button onClick={() => setOpen(false)}>Cancel</Button>
            <Button type="primary" onClick={addKeywords}>
              Add
            </Button>
          </Space>
        }
      >
        <TextArea
          placeholder="Keywords (use comma or Enter to separate)"
          value={keywords}
          onChange={(e) => setKeywords(e.target.value)}
        />
      </Modal>
    </>
  )
}

export default AddKeywords
